module.exports = __webpack_public_path__ + "img/test1.b78e5fdf.png";